import React from 'react';
import winBigBanner from './assets/banner.png';
import winBigBannerMobile from './assets/banner-mobile.png';
import './WinBigBanner.scss';
import useWindowDimensions from '../../hooks/useWindowDimensions';

export const WinBigBanner: React.FC = () => {
  const { width } = useWindowDimensions();

  return (
    <div className="win-big-banner">
      {width > 768 ? (
        <img src={winBigBanner} alt="Win Big Banner" className="banner-images" />
      ) : (
        <img src={winBigBannerMobile} alt="Win Big Banner" className="banner-images" />
      )}
    </div>
  );
};
